export default {
  cropperAspectRatio() {
    return 270/220
  },

  itemPicture() {
    if (this.holiday && this.holiday.picture && !this.holiday.picture.match(/base64/g)) {
      const baseUrl = process.env.VUE_APP_BASE_URL

      return `${baseUrl}/assets/img/holiday/${this.holiday.picture}?${Math.random()}`
    }

    if (this.holiday && this.holiday.picture && this.holiday.picture.match(/base64/g)) {
      return this.holiday.picture
    }
  },
}
